import type { GlobalToken } from 'antd'
import {
  BookOpen,
  DollarSign,
  Heart,
  Info,
  LayoutGrid,
  Plug,
  Store
} from 'lucide-react'
import type { ComponentType, CSSProperties } from 'react'

type PresetIcon = ComponentType<{
  size?: number
  color?: string
  className?: string
  style?: CSSProperties
}>

type DemoPresetInfoItem = Readonly<{
  icon: PresetIcon
  colorToken: keyof GlobalToken
  titleKey: string
  descriptionKey: string
  order: number
}>

export const demoPresetsInfo = {
  no_data: {
    icon: Info,
    colorToken: 'magenta6',
    titleKey: 'demoPresets_noData_title',
    descriptionKey: 'demoPresets_noData_description',
    order: 1
  },

  generic: {
    icon: LayoutGrid,
    colorToken: 'geekblue6',
    titleKey: 'demoPresets_generic_title',
    descriptionKey: 'demoPresets_generic_description',
    order: 2
  },

  information_technology: {
    icon: Plug,
    colorToken: 'geekblue6',
    titleKey: 'demoPresets_informationTechnology_title',
    descriptionKey: 'demoPresets_informationTechnology_description',
    order: 3
  },

  healthcare: {
    icon: Heart,
    colorToken: 'red6',
    titleKey: 'demoPresets_healthcare_title',
    descriptionKey: 'demoPresets_healthcare_description',
    order: 4
  },

  education: {
    icon: BookOpen,
    colorToken: 'purple6',
    titleKey: 'demoPresets_education_title',
    descriptionKey: 'demoPresets_education_description',
    order: 5
  },

  retail: {
    icon: Store,
    colorToken: 'volcano6',
    titleKey: 'demoPresets_retail_title',
    descriptionKey: 'demoPresets_retail_description',
    order: 6
  },

  finance: {
    icon: DollarSign,
    colorToken: 'blue6',
    titleKey: 'demoPresets_finance_title',
    descriptionKey: 'demoPresets_finance_description',
    order: 7
  }
} as const satisfies Record<string, DemoPresetInfoItem>
